import React from 'react';
import classes from './Solutions.module.scss'
import {Link, useLocation} from "react-router";
import arrowIcon from '../../media/icons/arrowRightBlack.svg'
import { useTranslation } from 'react-i18next';

const Solutions = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const currentPath = pathname.replace(/\/+$/, '');

    const solutionsBlocks = t('solutions.solutionsBlocks', {returnObjects: true})

    return (
        <div className={classes.solutions}>
            <div>
                <h2>{t('solutions.title')}</h2>
            </div>
            <div>
                <div className={classes.blocks}>
                    {solutionsBlocks.filter(({link}) => link !== currentPath).map(({image, text, link}) => <Link key={link} to={`../..${link}`}>
                        <img alt={text} src={require(`./media/${image}`)} className={classes["image"]}/>
                        <span>{text}</span>
                    </Link>)}
                    <Link className={classes['arrow-block']} to={'../../solutions'}>
                        <div>
                            <img alt="" className={classes.arrow} src={arrowIcon}/>
                        </div>
                        <span>{t('solutions.buttonText')}</span>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Solutions;